import './membership-detail-table.component.scss';

import type { ComponentChildren } from 'preact';

export interface MembershipDetailRow {
  /** stable key for the row; the label is translated, so it cannot be the key */
  key: string;
  label: string;
  /** a `<p>` or plain text -- never a heading, so the value takes the theme's body type */
  value: ComponentChildren;
  /** links or buttons, right-aligned in a third column; they keep their own handlers */
  actions?: ComponentChildren;
}

interface Props {
  rows: MembershipDetailRow[];
  /** the h5 above a table (Membership, Billing); omitted where the card already has a title */
  caption?: string;
  className?: string;
}

/**
 * SNGL-7386: the account page's label/value tables -- the account info column, Shipping Address and Payment
 * Method all render through this, so they share one set of markup rules: the label is an h6 in a `th`, the
 * value a `p` in a `td`, any actions in a third column. Type sizes all come from the theme.
 */
export const MembershipDetailTable = ({ rows, caption, className = '' }: Props) => {
  if (rows.length === 0) {
    return null;
  }
  const hasActions = rows.some((row) => row.actions);
  return (
    <div class={`single-membership-detail ${className}`}>
      {caption && <h5 class="h5 single-h5 single-membership-detail-caption">{caption}</h5>}
      <table class="single-membership-detail-table">
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <th scope="row">
                <h6 class="h6 single-h6">{row.label}</h6>
              </th>
              <td>{row.value}</td>
              {hasActions && <td class="single-membership-detail-actions">{row.actions}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
